<template>
  <BaseCheckboxListItem
    :title="title"
    :selected="isSelected"
    :description="perspectiveString"
    :trailing-text="!survey.isFinished ? $t('survey.state.notFinished') : undefined"
    icon="ballot"
  />
</template>

<script setup lang="ts">
  import { useDisplayDate } from '@/core/composables/use-display-date'
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import type { SurveySelectionPreview } from '@/modules/profile/composables/use-evaluation-profile'
  import BaseCheckboxListItem from '../base/list-item/BaseCheckboxListItem.vue'
  import { resolvePerspectiveLabel } from '@/core/models/perspective-label'
  import { SELF_PERSPECTIVE_KEY, type Perspective } from '@/core/models/perspective'

  interface Props {
    survey: SurveySelectionPreview
    isSelected: boolean
    topicPerspectives?: ReadonlyArray<Perspective>
  }

  const props = defineProps<Props>()

  const { t } = useI18n()
  const perspectiveString = computed(() => {
    const result: string[] = []

    for (const perspective of props.survey.perspectives) {
      if (perspective.key === SELF_PERSPECTIVE_KEY) {
        result.push(t('perspectives.widthCount.self', { count: perspective.numberOfFeedbacks }))
        continue
      }

      const label = resolvePerspectiveLabel(perspective.key, props.topicPerspectives ?? [], {
        kind: 'nameShort',
        count: perspective.numberOfFeedbacks,
        selfLabel: t('perspectives.self'),
      })
      result.push(`${perspective.numberOfFeedbacks} ${t('common.fromLowercase')} ${label}`)
    }

    return result.filter(Boolean).join(' · ')
  })

  const title = computed(() => {
    if (props.survey.title) {
      return props.survey.title
    }
    return useDisplayDate(props.survey.updatedAt, { dayName: 'short' }).value
  })
</script>
